import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth-service.service';
import { environment } from 'src/environments/environment';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (req.url.includes(environment.afmApis.topItems.baseUrl) || req.url.includes(environment.afmApis.be.baseUrl)) {
    const authService = inject(AuthService);
    const newReq = req.clone({
      headers: req.headers.append('Authorization', `Bearer ${authService.idToken() ?? ''}`),
    });
    return next(newReq);
  } else {
    return next(req);
  }
}

export function userIdInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (req.url.includes(environment.afmApis.topItems.baseUrl) || req.url.includes(environment.afmApis.be.baseUrl)) {
    const authService = inject(AuthService);
    const newReq = req.clone({
      headers: req.headers.append('X-User-Id', authService.user()?.uid ?? ''),
    });
    return next(newReq);
  } else {
    return next(req);
  }
}
